'use client';

import Link from 'next/link';
import { SecondaryNavButton } from './components/SecondaryNavButton';
import { Icon } from '@goed/ui-components';
import { CartIndicator } from '@goed-platform/cart/ui';
import { RoutesEnum } from '@goed-platform/shared/types';
import { SVGShoppingBag } from '@goed-platform/shared/utils';
import { useReactiveVar } from '@apollo/client';
import { cartVarUld } from '@goed-platform/shared/data-access';
import { useTranslation } from 'next-i18next';
import { Subheader } from '../../../layout-blocks/subheader/subheader';
import { Category } from '@goed-platform/graphql/types';
import { useState } from 'react';

export const SecondaryNavigation = ({ categories }: { categories: Category[] }): JSX.Element => {
    const { t } = useTranslation();
    const cartUld = useReactiveVar(cartVarUld);
    const [showCategories, setShowCategories] = useState(false);

    return (
        <div className="secondary-nav">
            <div className="secondary-nav__inner">
                <div className="secondary-nav__col">
                    <Link href={`${process.env.NEXT_PUBLIC_BASE_SHOP_URL}`}>
                        <a className="secondary-nav__link">
                            <Icon name="retour" />
                            <span>terug naar webshop</span>
                        </a>
                    </Link>
                    <SecondaryNavButton
                        modButton
                        modExpendable
                        label="categorieën"
                        onClick={() => setShowCategories(true)}
                    />
                </div>
                <div className="secondary-nav__col">
                    <CartIndicator
                        href={RoutesEnum.rentalStoreCart}
                        text="openstaande reservaties"
                        quantity={cartUld?.totalQuantity}
                        Icon={SVGShoppingBag}
                        iconTitle="shopping-bag"
                        className="text-white"
                        indicatorClassName="bg-primary"
                    />
                </div>
            </div>
            <Subheader
                baseUrl={RoutesEnum.rentalStoreLanding}
                title={t('ULD.title')}
                visible={showCategories}
                setVisible={setShowCategories}
                categories={categories}
            />
        </div>
    );
};
